import { plainObjectsId } from './formsData';
import { serialize } from 'object-to-formdata';

export function prepareRegisterFormData(data) {
  const plainIdsData = {
    ...plainObjectsId(data),
    languages: data.languages.map(plainObjectsId),
    workVisa: plainObjectsId(data.workVisa),
    workExperience: data.workExperience.map(plainObjectsId),
    additionalQuestions: plainObjectsId(data.additionalQuestions),
    documents: {
      ...data.documents,
      files: data.documents.files.map(plainObjectsId),
    }
  };

  return serialize(
    plainIdsData,
    {
      nullsAsUndefineds: true,
      indices: true,
    }
  );
}
